import { render, staticRenderFns } from "./TarjetaUsuario.vue?vue&type=template&id=31299362&"
import script from "./TarjetaUsuario.vue?vue&type=script&lang=js&"
export * from "./TarjetaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports